// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 18", width: "18", height: "18" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", null,
                React.createElement("path", { d: "M336.5,314 L321.5,314 C320.672,314 320,314.672 320,315.5 L320,326.511022 C320,327.339022 320.672,328 321.5,328 L326,328 L329,332 L332,328 L336.5,328 C337.328,328 338,327.339022 338,326.511022 L338,315.5 C338,314.672 337.328,314 336.5,314 Z", transform: "translate(-320 -314)" })))));
};
Icon.displayName = 'CommentBubble18x18';
export default Icon;
//# sourceMappingURL=CommentBubble18x18.js.map